import React from 'react';
import { Link } from 'react-router-dom';

type NavItemElementProps = {
  itemRoute: string;
  children: React.ReactNode;
  className?: string;
};

const NavItemElement: React.FC<NavItemElementProps> = ({
  itemRoute,
  children,
  className,
}) =>
  itemRoute === '' ? (
    <div className={className}>{children}</div>
  ) : (
    <Link className={className} to={itemRoute}>
      {children}
    </Link>
  );

export default NavItemElement;
